import { useState, useEffect } from "react";

type OldBrowserDetectionResult = { isOldBrowser: boolean };

const hasModernBrowserFeatures = (): boolean => {
  const requiredFeatures = [
    typeof Promise !== "undefined",
    typeof fetch !== "undefined",
    typeof URL !== "undefined",
    typeof Map !== "undefined",
    typeof Set !== "undefined",
    typeof ResizeObserver !== "undefined",
    typeof globalThis !== "undefined",
    typeof globalThis.AbortController !== "undefined",
    typeof globalThis.IntersectionObserver !== "undefined",
  ];

  return requiredFeatures.every(Boolean);
};

const hasLegacyEngineSignature = (userAgent: string): boolean => {
  return /MSIE|Trident\//.test(userAgent) || /Edge\/(1[0-8]|[1-9])\./.test(userAgent);
};

const detectOldBrowser = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent || "";

  if (hasLegacyEngineSignature(userAgent)) {
    return true;
  }

  return !hasModernBrowserFeatures();
};

export const useOldBrowserDetection = (): OldBrowserDetectionResult => {
  const [isOldBrowser, setIsOldBrowser] = useState(false);

  useEffect(() => {
    setIsOldBrowser(detectOldBrowser());
  }, []);

  return { isOldBrowser };
};
